export const DEFAULT_SIDECAR_URL = "http://localhost:8969";
export const DEFAULT_SIDECAR_STREAM_URL = new URL("/stream", DEFAULT_SIDECAR_URL).href;
